import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';

interface Props {
  type: DashboardConnectorType;
  // Extra pixels added to the lower vertical segment (the one reaching down to the first path card) so
  // the foundations→first-path bridge lands on the path card border. Drawn via overflow below the
  // viewport (the SVG layout height stays 111), so the path card below does not move.
  verticalTail?: number;
  verticalHead?: number;
}

export const ShortPathConnector: FC<Props> = ({ type, verticalTail = 0, verticalHead = 0 }) => {
  const connectorColors = useUnitConnectorColors();
  const tailBottom = 111 + verticalTail;
  const headTop = -verticalHead;
  const shortPathConnectors = {
    locked: (
      <svg
        width="270"
        height="111"
        viewBox="0 0 270 111"
        fill="none"
        className="tw-overflow-visible"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_2169_36998" fill="white">
          <path d="M0 56C0 51.5817 3.58172 48 8 48H270V55C270 59.4183 266.418 63 262 63H0V56Z" />
        </mask>
        <path
          d="M2.97754 59V67H0V59H2.97754ZM14.8867 59V67H8.93164V59H14.8867ZM26.7959 59V67H20.8408V59H26.7959ZM38.7041 59V67H32.75V59H38.7041ZM50.6133 59V67H44.6592V59H50.6133ZM62.5225 59V67H56.5684V59H62.5225ZM74.4316 59V67H68.4775V59H74.4316ZM86.3408 59V67H80.3867V59H86.3408ZM98.25 59V67H92.2959V59H98.25ZM110.159 59V67H104.204V59H110.159ZM122.068 59V67H116.113V59H122.068ZM133.978 59V67H128.022V59H133.978ZM145.887 59V67H139.932V59H145.887ZM157.796 59V67H151.841V59H157.796ZM169.704 59V67H163.75V59H169.704ZM181.613 59V67H175.659V59H181.613ZM193.522 59V67H187.568V59H193.522ZM205.432 59V67H199.478V59H205.432ZM217.341 59V67H211.387V59H217.341ZM229.25 59V67H223.296V59H229.25ZM241.159 59V67H235.204V59H241.159ZM253.068 59V67H247.113V59H253.068ZM265.062 62.3926L265.782 64.1299C263.93 65.7105 261.592 66.7392 259.022 66.9561V59H262C262.555 59 263.098 58.9709 263.621 58.917L265.062 62.3926ZM270 55C270 56.087 269.852 57.1393 269.581 58.1406L269.393 58.0625L268.159 57.5508C269.308 56.8582 270 55.9702 270 55ZM0.607422 52.9375L1.83984 53.4482C0.690915 54.1408 0 55.0299 0 56C0 54.9128 0.146961 53.8599 0.417969 52.8584L0.607422 52.9375ZM10.9775 52H8C7.44426 52 6.90173 52.0281 6.37793 52.082L4.9375 48.6074L4.2168 46.8701C6.06947 45.2892 8.40723 44.2608 10.9775 44.0439V52ZM22.8867 44V52H16.9316V44H22.8867ZM34.7959 44V52H28.8408V44H34.7959ZM46.7041 44V52H40.75V44H46.7041ZM58.6133 44V52H52.6592V44H58.6133ZM70.5225 44V52H64.5684V44H70.5225ZM82.4316 44V52H76.4775V44H82.4316ZM94.3408 44V52H88.3867V44H94.3408ZM106.25 44V52H100.296V44H106.25ZM118.159 44V52H112.204V44H118.159ZM130.068 44V52H124.113V44H130.068ZM141.978 44V52H136.022V44H141.978ZM153.887 44V52H147.932V44H153.887ZM165.796 44V52H159.841V44H165.796ZM177.704 44V52H171.75V44H177.704ZM189.613 44V52H183.659V44H189.613ZM201.522 44V52H195.568V44H201.522ZM213.432 44V52H207.478V44H213.432ZM225.341 44V52H219.387V44H225.341ZM237.25 44V52H231.296V44H237.25ZM249.159 44V52H243.204V44H249.159ZM261.068 44V52H255.113V44H261.068ZM270 44V52H267.022V44H270Z"
          fill="#EBE4DC"
          mask="url(#path-1-inside-1_2169_36998)"
        />
        <path
          d={`M7.5 48.1431C11.6421 48.1431 15 51.5009 15 55.6431L15 ${tailBottom}L2.38339e-07 ${tailBottom}L2.54809e-06 55.6431C2.72092e-06 51.5009 3.35787 48.1431 7.5 48.1431V48.1431Z`}
          fill="#EBE4DC"
        />
        <path
          d={`M270 ${headTop}L270 55.3572C270 59.4993 266.642 62.8572 262.5 62.8572V62.8572C258.358 62.8572 255 59.4993 255 55.3572L255 ${headTop}L270 ${headTop}Z`}
          fill="#EBE4DC"
        />
        <ellipse cx="262.5" cy="55.5" rx="7.5" ry="7.5" transform="rotate(-180 262.5 55.5)" fill="#BAAF9F" />
        <ellipse cx="7.5" cy="55.5" rx="7.5" ry="7.5" transform="rotate(-180 7.5 55.5)" fill="#BAAF9F" />
      </svg>
    ),
    unlocked: (
      <svg
        width="270"
        height="111"
        viewBox="0 0 270 111"
        fill="none"
        className="tw-overflow-visible"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_2169_36998" fill="white">
          <path d="M0 56C0 51.5817 3.58172 48 8 48H270V55C270 59.4183 266.418 63 262 63H0V56Z" />
        </mask>
        <path
          d="M0 56C0 49.3726 5.37258 44 12 44H270V52H8C3.58172 52 0 53.7909 0 56ZM270 55C270 61.6274 264.627 67 258 67H0V59H262C266.418 59 270 57.2091 270 55ZM270 55M0 63V48V63M0 63M270 48V63V48"
          className={connectorColors.fillBase}
          mask="url(#path-1-inside-1_2169_36998)"
        />
        <mask id="path-3-inside-2_2169_36998" fill="white">
          <path
            d={`M15 48.1431L15 ${tailBottom}L2.38339e-07 ${tailBottom}L2.52723e-06 56.1431C2.71158e-06 51.7248 3.58172 48.1431 8 48.1431L15 48.1431Z`}
          />
        </mask>
        <path
          d={`M19 48.1431L19 ${tailBottom}L11 ${tailBottom}L11 48.1431L19 48.1431ZM-4 ${tailBottom}L-4 60.1431C-4 53.5156 1.37259 48.1431 8 48.1431C5.79086 48.1431 4 51.7248 4 56.1431L4 ${tailBottom}L-4 ${tailBottom}ZM4 ${tailBottom}M2.86102e-06 48.1431L15 48.1431L2.86102e-06 48.1431M2.86102e-06 48.1431M15 ${tailBottom}L2.38339e-07 ${tailBottom}L15 ${tailBottom}`}
          className={connectorColors.fillBase}
          mask="url(#path-3-inside-2_2169_36998)"
        />
        <mask id="path-5-inside-3_2169_36998" fill="white">
          <path
            d={`M270 ${headTop}L270 54.8572C270 59.2754 266.418 62.8572 262 62.8572L255 62.8572L255 ${headTop}L270 ${headTop}Z`}
          />
        </mask>
        <path
          d={`M274 ${headTop}L274 50.8572C274 57.4846 268.627 62.8572 262 62.8572C264.209 62.8572 266 59.2754 266 54.8572L266 ${headTop}L274 ${headTop}ZM251 62.8572L251 ${headTop}L259 ${headTop}L259 62.8572L251 62.8572ZM259 62.8572M255 ${headTop}L270 ${headTop}L255 ${headTop}M255 ${headTop}M270 62.8572L255 62.8572L270 62.8572`}
          className={connectorColors.fillBase}
          mask="url(#path-5-inside-3_2169_36998)"
        />
        <ellipse
          cx="262.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 262.5 55.5)"
          className={connectorColors.fillAccent}
        />
        <ellipse
          cx="7.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 7.5 55.5)"
          className={connectorColors.fillAccent}
        />
      </svg>
    ),
    passed: (
      <svg
        width="270"
        height="111"
        viewBox="0 0 270 111"
        fill="none"
        className="tw-overflow-visible"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_2169_36998" fill="white">
          <path d="M0 56C0 51.5817 3.58172 48 8 48H270V55C270 59.4183 266.418 63 262 63H0V56Z" />
        </mask>
        <path
          d="M2.97754 59V67H0V59H2.97754ZM14.8867 59V67H8.93164V59H14.8867ZM26.7959 59V67H20.8408V59H26.7959ZM38.7041 59V67H32.75V59H38.7041ZM50.6133 59V67H44.6592V59H50.6133ZM62.5225 59V67H56.5684V59H62.5225ZM74.4316 59V67H68.4775V59H74.4316ZM86.3408 59V67H80.3867V59H86.3408ZM98.25 59V67H92.2959V59H98.25ZM110.159 59V67H104.204V59H110.159ZM122.068 59V67H116.113V59H122.068ZM133.978 59V67H128.022V59H133.978ZM145.887 59V67H139.932V59H145.887ZM157.796 59V67H151.841V59H157.796ZM169.704 59V67H163.75V59H169.704ZM181.613 59V67H175.659V59H181.613ZM193.522 59V67H187.568V59H193.522ZM205.432 59V67H199.478V59H205.432ZM217.341 59V67H211.387V59H217.341ZM229.25 59V67H223.296V59H229.25ZM241.159 59V67H235.204V59H241.159ZM253.068 59V67H247.113V59H253.068ZM265.062 62.3926L265.782 64.1299C263.93 65.7105 261.592 66.7392 259.022 66.9561V59H262C262.555 59 263.098 58.9709 263.621 58.917L265.062 62.3926ZM270 55C270 56.087 269.852 57.1393 269.581 58.1406L269.393 58.0625L268.159 57.5508C269.308 56.8582 270 55.9702 270 55ZM0.607422 52.9375L1.83984 53.4482C0.690915 54.1408 0 55.0299 0 56C0 54.9128 0.146961 53.8599 0.417969 52.8584L0.607422 52.9375ZM10.9775 52H8C7.44426 52 6.90173 52.0281 6.37793 52.082L4.9375 48.6074L4.2168 46.8701C6.06947 45.2892 8.40723 44.2608 10.9775 44.0439V52ZM22.8867 44V52H16.9316V44H22.8867ZM34.7959 44V52H28.8408V44H34.7959ZM46.7041 44V52H40.75V44H46.7041ZM58.6133 44V52H52.6592V44H58.6133ZM70.5225 44V52H64.5684V44H70.5225ZM82.4316 44V52H76.4775V44H82.4316ZM94.3408 44V52H88.3867V44H94.3408ZM106.25 44V52H100.296V44H106.25ZM118.159 44V52H112.204V44H118.159ZM130.068 44V52H124.113V44H130.068ZM141.978 44V52H136.022V44H141.978ZM153.887 44V52H147.932V44H153.887ZM165.796 44V52H159.841V44H165.796ZM177.704 44V52H171.75V44H177.704ZM189.613 44V52H183.659V44H189.613ZM201.522 44V52H195.568V44H201.522ZM213.432 44V52H207.478V44H213.432ZM225.341 44V52H219.387V44H225.341ZM237.25 44V52H231.296V44H237.25ZM249.159 44V52H243.204V44H249.159ZM261.068 44V52H255.113V44H261.068ZM270 44V52H267.022V44H270Z"
          className={connectorColors.fillLight}
          mask="url(#path-1-inside-1_2169_36998)"
        />
        <path
          d={`M7.5 48.1431C11.6421 48.1431 15 51.5009 15 55.6431L15 ${tailBottom}L2.38339e-07 ${tailBottom}L2.54809e-06 55.6431C2.72092e-06 51.5009 3.35787 48.1431 7.5 48.1431V48.1431Z`}
          className={connectorColors.fillBase}
        />
        <path
          d={`M270 ${headTop}L270 55.3572C270 59.4993 266.642 62.8572 262.5 62.8572V62.8572C258.358 62.8572 255 59.4993 255 55.3572L255 ${headTop}L270 ${headTop}Z`}
          className={connectorColors.fillBase}
        />
        <ellipse
          cx="262.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 262.5 55.5)"
          className={connectorColors.fillAccent}
        />
        <ellipse
          cx="7.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 7.5 55.5)"
          className={connectorColors.fillAccent}
        />
      </svg>
    ),
  };

  return shortPathConnectors[type];
};
